import React from 'react';
import { connect } from 'react-redux';
import { Field, Form as FinalForm } from 'react-final-form';
import { Button, Form, Label } from 'semantic-ui-react';
import FileUploader from 'components/FileUploader';
import {
  downloadDiscountScheme,
  updateDiscountSettings,
} from 'state/discountSettings/actions';
import PropTypes from 'prop-types';

const DiscountSettingsForm = props => {
  const { dispatch, discountSettingsIsLoading, discountSettings } = props;

  const onSubmitDiscountScheme = discountSchemes => {
    dispatch(updateDiscountSettings(discountSchemes));
  };

  const handleDownloadDiscountScheme = () => {
    dispatch(downloadDiscountScheme(discountSettings));
  };

  return (
    <FinalForm
      onSubmit={onSubmitDiscountScheme}
      render={({ handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <Field
            name="discountSchemes"
            component={FileUploader}
            label="Discount Schemes"
            required
            action
          >
            <Label>Discount Schemes</Label>
            <input name="bottomPrice" />
            <Button
              content="Submit"
              loading={discountSettingsIsLoading}
              primary
            />
          </Field>

          <Button
            content="Download discount_scheme.csv"
            basic
            type="button"
            onClick={handleDownloadDiscountScheme}
          />
        </Form>
      )}
    />
  );
};

const mapStateToProps = ({ discountSettings }) => ({
  discountSettingsIsLoading:
    discountSettings.discountSettings.discountSettingsIsLoading,
  discountSettings: discountSettings.discountSettings.discountSettings,
});

DiscountSettingsForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  discountSettingsIsLoading: PropTypes.bool.isRequired,
  discountSettings: PropTypes.arrayOf().isRequired,
};

export default connect(mapStateToProps)(DiscountSettingsForm);
